import typewriter from "../typewriter/segment";
import { getIdentifyInfo } from "@bigspring/core-components/src/lib/segment";

export const typewriterTrack = <
  E extends keyof typeof typewriter,
  P extends Partial<Parameters<(typeof typewriter)[E]>[0]>
>(
  event: E,
  props?: P
) => {
  const traits = getIdentifyInfo();
  const method: any = typewriter[event];
  const composedProps = { ...(props ?? {}), sessionId: traits.sessionId };
  method(composedProps, {
    context: { traits: traits.prevIdentifyParams },
  });
};
